import moment from 'moment';

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import Header from 'components/ui/Header';
import { useParams } from 'react-router-dom';

import TicketApi from 'api/ticket';
import AddCommentForm from './AddCommentForm';

export default function ViewChamadoPage() {
  const { t } = useTranslation();

  const params = useParams();
  const [ticket, setTicket] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCards = async (silence = false) => {
    setLoading(!silence);
    try {
      const ticket = await TicketApi.get(params.id);
      setTicket(ticket);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, [params.id]);

  if (!ticket) {
    return <div className="container">Chamado não encontrado!</div>;
  }

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  const formatDateTime = value => {
    if (!value) {
      return '--';
    }

    return moment(value).format('DD/MM/YYYY HH:mm');
  };

  const formatStatus = value => {
    return t(`status.${value?.toLowerCase()}`).toUpperCase();
  };

  const comments = (ticket.comments || [])
    .sort((a, b) => a.id - b.id)
    .map(comment => {
      const text = comment.description;

      return (
        <blockquote className="p-3" style={{ backgroundColor: '#eee', borderRadius: 10 }}>
          <p>{text}</p>
          <footer className="blockquote-footer mb-0">
            <cite>
              {comment?.creator?.name} em {formatDateTime(comment.created_at)}
            </cite>
          </footer>
        </blockquote>
      );
    });

  return (
    <>
      <Header>
        <div className="d-flex align-items-center">
          <div className="me-4">
            <Link to="/help">
              <FiArrowLeft size={24} />
            </Link>
          </div>

          <div>
            <h1 className="m-0 p-0 fw-lighter">Chamado #{ticket.id_seq}</h1>
          </div>
        </div>
      </Header>

      <div className="container">
        <div className="row mt-3">
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{ticket.title}</h5>
                <hr />
                <div className="mb-2">
                  <b>Descrição:</b> <p>{ticket.description}</p>
                </div>

                <div className="mb-2">
                  <b>Solicitante:</b> <p>{ticket?.creator?.name || '--'}</p>
                </div>

                <div className="mb-2">
                  <b>Data:</b> <p>{formatDateTime(ticket.created_at)}</p>
                </div>

                <div className="mb-2">
                  <b>Robô:</b> <p>{ticket?.bot?.name || '--'}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Andamento</h5>
                <hr />

                <div className="mb-2">
                  <b>Status:</b> <p>{formatStatus(ticket.status)}</p>
                </div>

                <div className="mb-2">
                  <b>Vencimento:</b> <p>{formatDateTime(ticket?.deadline_at)}</p>
                </div>

                <div className="mb-2">
                  <b>Responsavél:</b> <p>{ticket?.assignee?.name || '--'}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mt-4 mb-5">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Comentários</h5>
                <hr />

                {comments}

                <AddCommentForm id={params.id} onAddComment={fetchCards.bind(this, true)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
